<script setup lang="ts">
import { ref } from 'vue'
import { useSuiteStore } from '@/stores/useSuiteStore'
import pandora from '@/assets/logos/logo-pandora.svg'

const suiteStore = useSuiteStore()

const email = ref('')
const sent = ref(false)
const loading = ref(false)
const error = ref('')

async function submit() {
  error.value = ''
  if (!email.value) {
    error.value = 'Veuillez saisir votre email.'
    return
  }
  loading.value = true
  try {
    await suiteStore.suiteFetch('/auth/user/password/forgot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.value }),
    })
    // Always show success to avoid user enumeration
    sent.value = true
  } catch {
    error.value = 'Une erreur est survenue. Veuillez réessayer.'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-base-200">
    <div class="card w-full max-w-md bg-base-100 shadow-xl">
      <div class="card-body items-center text-center">
        <div class="mb-4">
          <component :is="pandora" class="w-32 mx-auto" />
        </div>
        <h2 class="card-title text-xl mb-2">Mot de passe oublié</h2>

        <template v-if="!sent">
          <p class="text-sm text-base-content/60 mb-4">
            Saisissez votre adresse email. Si un compte existe, vous recevrez un lien de réinitialisation.
          </p>

          <form class="w-full space-y-4" @submit.prevent="submit">
            <div class="form-control">
              <input
                v-model="email"
                type="email"
                placeholder="votre@email.com"
                class="input input-bordered w-full"
                autocomplete="username"
                required
              />
            </div>

            <div v-if="error" class="alert alert-error text-sm py-2">
              {{ error }}
            </div>

            <button
              type="submit"
              class="btn btn-primary w-full"
              :disabled="loading"
            >
              <span v-if="loading" class="loading loading-spinner loading-sm"></span>
              {{ loading ? 'Envoi...' : 'Envoyer le lien' }}
            </button>
          </form>
        </template>

        <template v-else>
          <div class="alert alert-success text-sm py-3">
            Si un compte est associé à cette adresse, un email de réinitialisation a été envoyé.
          </div>
        </template>

        <div class="mt-4">
          <router-link to="/auth/login" class="link link-hover text-sm text-base-content/60">
            Retour à la connexion
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
